@if (articleId) {
    <adapt-context-sidebar-content [context]="context"
                                   [fullScreen]="fullScreen">
        <h2 context-sidebar-title>{{ articleName || "Guidance" }}</h2>
        @if (articles.length > 1) {
            <dx-tab-panel [items]="articles">
                <div *dxTemplate="let item of 'title'">
                    <h4>{{ item.name }}</h4>
                </div>
                <div *dxTemplate="let item of 'item'">
                    <adapt-styled-implementation-kit [articleId]="item.articleId"
                                                     (articleName)="item.name = $event"
                                                     [contentStyle]="contentStyle"
                                                     [title]="title"></adapt-styled-implementation-kit>
                </div>
            </dx-tab-panel>
        } @else {
            <adapt-styled-implementation-kit [articleId]="firstArticle"
                                             (articleName)="articleNameUpdater.next($event)"
                                             [contentStyle]="contentStyle"
                                             [title]="title"
                                             [loadOnEmit]="loadOnEmit"></adapt-styled-implementation-kit>
        }
    </adapt-context-sidebar-content>
}
